import { PlusCircle } from "@phosphor-icons/react";
import { Container } from "./styles";
import { Box, TextField } from "@mui/material";
import { ClipLoader } from "react-spinners";
import { NormalText } from "../styles";
import { PreviewFile } from "./preview-file";

export const UploadFile = ({
  handleAddFile,
  label,
  file,
  isLoadingFile = false,
  handleRemoveFile,
  id = null,
  message = "",
}) => {
  function handleFileChange(event) {
    handleAddFile(event);
    event.target.value = null;
  }

  return (
    <>
      {isLoadingFile ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"24px"}>
          <ClipLoader loading={isLoadingFile} color="#030303" size={50} />
        </Box>
      ) : (
        <>
          {message && <NormalText>{message}</NormalText>}
          <Box display={"flex"} gap={"24px"}>
            <Container htmlFor="file">
              <PlusCircle size={32} fill={"#8C8C8C"} />
              {label}
              <TextField
                type="file"
                onChange={handleFileChange}
                id="file"
                sx={{
                  display: "none",
                }}
              />
            </Container>
            {file && (
              <PreviewFile
                file={file}
                id={id}
                handleRemoveFile={handleRemoveFile}
              />
            )}
          </Box>
        </>
      )}
    </>
  );
};
